
import { useNavigate } from "react-router-dom";
import { 
  NavigationOptions,
  navigateTo,
  navigateToTerms, 
  navigateToProfile, 
  navigateToAuth,
  navigateAfterFlow,
  saveCurrentPath,
  getOriginalPath
} from "@/services/NavigationService";

export const useNavigation = () => {
  const navigate = useNavigate();

  return {
    navigateTo: (path: string, options?: NavigationOptions) => 
      navigateTo(navigate, path, options),
    
    navigateToTerms: (options?: NavigationOptions) => 
      navigateToTerms(navigate, options),
    
    navigateToProfile: (options?: NavigationOptions) => 
      navigateToProfile(navigate, options),
    
    navigateToAuth: (options?: NavigationOptions) => 
      navigateToAuth(navigate, options),
    
    navigateAfterFlow: (options?: NavigationOptions) => 
      navigateAfterFlow(navigate, options),
    
    saveCurrentPath,
    getOriginalPath
  };
};
